import React, { FC } from "react";

import { Button } from "antd";

import styles from "./ErrorAlert.module.scss";

import { useAppSelector } from "@/hooks/redux";
import { deleteUnrecordedExamination } from "@/store/reducers/currentData/asyncActionCreators";

const ErrorAlert: FC = () => {
  const { plcError, unrecordedExaminationError } = useAppSelector(
    (state) => state.currentDataReducer
  );

  if (!plcError && !unrecordedExaminationError) {
    return null;
  }

  const handleDelete = () => {
    deleteUnrecordedExamination();
  };

  return (
    <div data-testid="error-alert" className={styles.container}>
      {unrecordedExaminationError ? (
        <>
          <span className={styles.message}>
            There is unrecorded examination, can't start new examination
          </span>
          <Button size="small" type="default" onClick={handleDelete}>
            Delete this exam
          </Button>
        </>
      ) : (
        <span className={styles.message}>{plcError}</span>
      )}
    </div>
  );
};

export default ErrorAlert;
